import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminBookings from "./Pages/AdminBookings";
import AdminAddingRooms from "./Pages/AdminAddingroom";
import AdminLayout from "./components/AdminLayout";
import AdminRoomsList from "./Pages/AdminRoomListing";
import AdminBookingCalendar from "./Pages/AdminBookingsCalander";
import AdminLogin from "./Pages/AdminLogin";
import AdminRegister from "./Pages/AdminRegisterPage";
import AdminContactPage from "./Pages/AdminContactmessages";

function App() {
  return (
  <Router>
  <Routes>
    <Route path="/" element={<Navigate to="/admin/login" />} />
<Route path="/admin/login" element={<AdminLogin />} />
<Route path="/admin/register" element={<AdminRegister />} />
    <Route path="/admin" element={<AdminLayout />}>
      <Route path="bookings" element={<AdminBookings />} />
      <Route path="rooms" element={<AdminAddingRooms />} />
      <Route path="rooms-list" element={<AdminRoomsList />} />
      <Route path="/admin/bookings/calendar" element={<AdminBookingCalendar />} />
            <Route path="/admin/bookings/contact" element={<AdminContactPage/>} />


    </Route>

    <Route path="*" element={<h2>Page Not Found</h2>} />
  </Routes>
</Router>

  );
}

export default App;
